import { h, Fragment } from "preact";
import { useState, useEffect, } from "preact/hooks";
import {

	Divider,
	Grid,
	Stack,
	Typography,
} from "@mui/material";

import FormField from "../Common/FormField";
import FormMultiToggle from "../Common/FormMultiToggle";
import FormToggle from "../Common/FormToggle";
import FormDate from "../Common/FormDate";
import Ges from "../GES/";
import Dpe from "../DPE/";

export default function Office({ upperState, upperHandleChange }) {
	const [state, setState] = useState({ changes: false })

	const handleChange = (event) => {

		upperHandleChange(event);
	};


	return (
		<Stack spacing={1}>
			<Grid container spacing={1}>
				<Grid item md={6} xs={12} >
					<Stack spacing={1}>
						<FormField upperState={upperState} id="surface" placeholder="Surface habitable en m2" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer la surface habitable du bureau</Typography>{upperState.co_property == "O" && <Typography>dite "surface loi Carrez".</Typography>}</Stack>} />
						<Divider />
						<FormToggle upperState={upperState} id="co_property" handleChange={handleChange} />

						{upperState.co_property == "O" && (<FormField upperState={upperState} id="co_property_lots" placeholder="No" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le numéro de lot de copropriété du bureau.</Typography></Stack>} />)}


						<Divider />
						<FormToggle upperState={upperState} id="dpe_and_ges_available" handleChange={handleChange} helper={<Stack><Typography>Diagnostic de Performance Energétique.</Typography></Stack>} />
						{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="dpe" placeholder="DPE" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette énergie</Typography><Dpe nb={upperState.dpe} /></Stack>} />)}
						{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="ges" placeholder="GES" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette climat</Typography><Ges nb={upperState.ges} /></Stack>} />)}
						<Divider />
						<FormMultiToggle upperState={upperState} options={[{ o: "49", l: "Avant 1949" }, { o: "97", l: "Entre les deux" }, , { o: "00", l: "Après 1996" }, { o: "?", l: "Ne sais pas" }]} id="construction_year" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />
						<Divider />
						<FormToggle upperState={upperState} id="is_not_free" handleChange={handleChange} helper={<Stack><Typography>Indiquez si le bien fait l'objet d'un contrat de location.</Typography></Stack>} />
						{upperState.is_not_free == "O" && (<FormField upperState={upperState} id="rent" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer le montant du loyer annuel hors charges.</Stack>} />)}
						{upperState.is_not_free == "O" && (<FormDate upperState={upperState} id="rent_term" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer la date de fin du contrat de location (bail).</Stack>} />)}
					</Stack>
				</Grid>

			</Grid >
		</Stack>
	);
}